module.exports = ASVideoPlayer;


//////////////////
// WEBPACK FOOTER
// external "ASVideoPlayer"
// module id = 249
// module chunks = 1 3